import axios from "axios";
import { Text } from "components";

import React, { forwardRef, useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver"; // Install file-saver if you don't have it: npm install file-saver

import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  Legend,
  Pie,
  PieChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { toast, ToastContainer } from "react-toastify";
import { formatRupee } from "utils/helpingMethods/formatRupee";
import CustomSelect from "components/SmallComponents/CustomSelect";
import {
  FaChartLine,
  FaMoneyBillWave,
  FaUsers,
  FaUserTie,
} from "react-icons/fa6";
import { AgGridReact } from "ag-grid-react";

const SupplierSalesReport = forwardRef(({ hiddenSection, ...props }, ref) => {
  const [download, setDownload] = useState(false);
  const gridRef = useRef();
  const [flag, setFlag] = useState(false);

  const today = new Date();
  const formattedToday = today.toISOString().split("T")[0];
  const thirtyDaysAgo = new Date(today);
  thirtyDaysAgo.setDate(1); // Set to the first day of the current month
  thirtyDaysAgo.setMonth(thirtyDaysAgo.getMonth() - 2); // Go back one month
  // const formattedThirtyDaysAgo = thirtyDaysAgo.toISOString().split('T')[0];
  const firstDayOfCurrentMonth = new Date(
    today.getFullYear(),
    today.getMonth(),
    1
  );
  const formattedThirtyDaysAgo = `${firstDayOfCurrentMonth.getFullYear()}-${String(
    firstDayOfCurrentMonth.getMonth() + 1
  ).padStart(2, "0")}-01`;

  const [timedateflag, setTimeDateFlag] = useState(false);
  const [revenuedata, setRevenueData] = useState([]);
  const [customerWiseRevenuedata, setCustomerWiseRevenueData] = useState([]);
  const [revenuedataforExcel, setRevenueDataForExcel] = useState([]);
  const [supplierId, setSupplierId] = useState();
  const [supplierList, setSupplierList] = useState([]);
  const [toDate, setToDate] = useState(formattedToday);
  const [fromDate, setFromDate] = useState(formattedThirtyDaysAgo);
  const [showChart, setShowChart] = useState(false);
  const [pieChartDate, setPieChartData] = useState([]);
  const token = sessionStorage.getItem("token");
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Subtract one year
  today.setFullYear(today.getFullYear() - 1);
  const oneYearPreviousDate = today.toISOString().split("T")[0];

  useEffect(() => {
    setTimeout(() => {
      revenueDataGet();
    }, 1000);
  }, [fromDate, toDate, supplierId]);

  const obj = {
    start_date: fromDate,
    end_date: toDate,
    supplier_id: supplierId,
  };

  const revenueDataGet = () => {
    axios
      .post("/api/purple-fusion/revenuereport/supplier/get", obj, headers)
      .then((response) => {
        setRevenueData(
          response.data.sort((a, b) => b.total_amount - a.total_amount)
        );
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //Pie chart Data
  useEffect(() => {
    setTimeout(() => {
      customerWiserevenueDataGet();
    }, 500);
  }, [fromDate, toDate]);

  const obj1 = {
    start_date: fromDate,
    end_date: toDate,
  };

  const customerWiserevenueDataGet = () => {
    axios
      .post(
        "/api/purple-fusion/revenuereport/supplier/get/supplierwise/sales",
        obj1,
        headers
      )
      .then((response) => {
        setCustomerWiseRevenueData(
          response.data.sort((a, b) => b.total_amount - a.total_amount)
        );
        const transformedData = response.data.map((item) => ({
          ...item,
          total_amount: Number(item.total_amount - item.total_tax), // Convert total_amount to a number
        }));
        setPieChartData(transformedData);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //for excel...
  useEffect(() => {
    setTimeout(() => {
      revenueDataGetForExcel();
    }, 1500);
  }, [fromDate, toDate, supplierId]);

  const obj_for_excel = {
    start_date: fromDate,
    end_date: toDate,
    supplier_id: supplierId,
  };
  //for excel...
  const revenueDataGetForExcel = () => {
    axios
      .post(
        "/api/purple-fusion/revenuereport/supplier/get/exceldata",
        obj_for_excel,
        headers
      )
      .then((response) => {
        setRevenueDataForExcel(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //for getting supplier list ....
  useEffect(() => {
    if (!hiddenSection) {
      getSupplierList();
    }
  }, []);

  const getSupplierList = () => {
    axios
      .post(
        "/api/purple-fusion/companypurchaseorderreport/get/supplier",
        {},
        headers
      )
      .then((response) => {
        setSupplierList(response.data);
        // console.log(response.data);
      })
      .catch((error) => {
        console.error("Error in fetching company purchase items", error);
      });
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            padding: "5px",
            border: "1px solid #ccc",
          }}
        >
          {/* Rounding the value to 2 decimal places */}
          <p>{`Total Sales: ${formatRupee(payload[0].value)}`}</p>
        </div>
      );
    }
    return null;
  };

  const CustomTooltipforPie = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            backgroundColor: "white",
            padding: "4px 8px", // Reduced padding
            border: "1px solid #ccc",
            fontSize: "12px", // Adjust font size here
          }}
        >
          <p>{`${payload[0].payload.payload.suppliername}: ${formatRupee(
            payload[0].value
          )}`}</p>
        </div>
      );
    }
    return null;
  };

  const DownloadExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Supplier Purchase Report");
    // Helper function to format dates safely
    const formatDate = (date) => {
      if (typeof date === "string") {
        const [day, month, year] = date.split("/").map(Number);
        const parsedDate = new Date(year, month - 1, day); // Month is zero-indexed
        if (isNaN(parsedDate.getTime())) {
          console.log(`Invalid date: ${date}`);
          return "";
        }
        const dayStr = parsedDate.getDate().toString().padStart(2, "0");
        const monthStr = (parsedDate.getMonth() + 1)
          .toString()
          .padStart(2, "0");
        const yearStr = parsedDate.getFullYear();
        return `${dayStr}/${monthStr}/${yearStr}`;
      } else if (date instanceof Date && !isNaN(date.getTime())) {
        const dayStr = date.getDate().toString().padStart(2, "0");
        const monthStr = (date.getMonth() + 1).toString().padStart(2, "0");
        const yearStr = date.getFullYear();
        return `${dayStr}/${monthStr}/${yearStr}`;
      }
      console.log(`Invalid date type: ${date}`);
      return "";
    };

    // Filter out any invalid dates while extracting unique dates
    const uniqueSuppliers = Array.from(
      new Set(revenuedataforExcel.map((data) => data.supplier_name))
    );
    const uniqueDates = Array.from(
      new Set(
        revenuedataforExcel
          .map((data) => {
            const date = new Date(data.createdon);
            return isNaN(date.getTime()) ? null : date.toLocaleDateString();
          })
          .filter(Boolean)
      )
    );

    //formate headers date
    const formatHeadersDate = (dateStr) => {
      console.log(dateStr);

      const [year, month, day] = dateStr.split("-"); // Split the date string
      return `${day}-${month}-${year}`; // Return in DD-MM-YYYY format
    };
    // Add report title and date range at the top
    worksheet.addRow(["Report Name:", "Suppier Sales Report"]);
    worksheet.addRow([
      "From Date:",
      fromDate ? formatHeadersDate(fromDate) : "",
    ]);
    worksheet.addRow(["To Date:", toDate ? formatHeadersDate(toDate) : ""]);

    if (flag == true) {
      worksheet.addRow([
        "Supplier Name:",
        revenuedataforExcel ? revenuedataforExcel[0].supplier_name : "",
      ]);
    } else {
      worksheet.addRow([]);
    }
    worksheet.addRow([]); // Empty row for spacing

    // Define headers with 'SR.NO', 'Customer Name', and 'Total'
    const headers = [
      "Sr.No",
      "Supplier Name",
      ...uniqueDates.map((date) => formatDate(date)),
      "Total", // Add the 'Total' column header
    ];
    worksheet.addRow(headers);

    // Freeze the top 5 rows (title and header)
    worksheet.views = [{ state: "frozen", ySplit: 6 }];

    // Apply bold font and left alignment to the first 3 rows of column 1
    for (let i = 1; i <= 4; i++) {
      const cell = worksheet.getCell(i, 1); // Get cell in column 1
      cell.font = { bold: true }; // Make text bold
    }

    // Remove gridlines for the first 4 rows by setting the fill to match the background
    for (let i = 1; i <= 5; i++) {
      for (let j = 1; j <= headers.length; j++) {
        const cell = worksheet.getRow(i).getCell(j);
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFFFFFFF" }, // white background
        };
      }
    }

    // Add styles to the header row (5th row)
    worksheet.getRow(6).eachCell({ includeEmpty: true }, (cell) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } }; // white text color
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FF368BC1" }, // blue background color
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    // Populate data with a total for each customer row
    uniqueSuppliers.forEach((supplierName, supplierIndex) => {
      const row = [supplierIndex + 1, supplierName];
      let rowTotal = 0; // Initialize a variable to hold the total for the row

      uniqueDates.forEach((date) => {
        // Calculate the total amount for each date
        const totalAmount = revenuedataforExcel
          .filter(
            (data) =>
              data.supplier_name === supplierName &&
              new Date(data.createdon).toLocaleDateString() === date
          )
          .reduce((acc, data) => acc + Number(data.total_amount), 0);

        // Round the total amount to 2 decimal places
        const roundedAmount = Math.round(totalAmount * 100) / 100;
        row.push(roundedAmount); // Add total amount as a number to the row
        rowTotal += roundedAmount; // Add to row total
      });

      row.push(rowTotal); // Add the total for the row at the end
      worksheet.addRow(row);
    });

    // After adding all the rows, set the number format for those columns
    worksheet.eachRow((row, rowNumber) => {
      row.eachCell((cell, colNumber) => {
        if (colNumber > 2) {
          cell.numFmt = "0.00"; // Set the cell format to two decimal places
        }
      });
    });

    // Apply left alignment to columns A and B
    worksheet.getColumn(1).alignment = { horizontal: "left" };
    worksheet.getColumn(2).alignment = { horizontal: "left" };

    // Apply right alignment to the remaining data columns
    for (let i = 4; i <= worksheet.columns.length; i++) {
      worksheet.getColumn(i).alignment = { horizontal: "right" };
    }

    // Save the workbook
    workbook.xlsx.writeBuffer().then((buffer) => {
      saveAs(
        new Blob([buffer]),
        `Supplier Purchase Report ${new Date().toISOString().slice(0, 10)}.xlsx`
      );
    });
  };

  //for pdf and excel download title..(timeStapm)
  const [dateTime, setDateTime] = useState("");
  useEffect(() => {
    const currentTimestamp = new Date();
    const formattedDate = currentTimestamp
      .toLocaleDateString([], {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/\//g, "-");
    const formattedDateTime = `${formattedDate}`;
    setDateTime(formattedDateTime);
  }, [timedateflag]);

  //for reset input filed...
  const [resetkey, setResetKey] = useState(0);
  useEffect(() => {
    setResetKey((prev) => prev + 1);
  }, [toDate, fromDate]);

  //for pie chart colors...

  const COLORS = [
    "#008b8b",
    "#b8860b",
    "#bdb76b",
    "#a9a9a9",
    "#8b0000",
    "#e9967a",
    "#0088FE",
    "#00ced1",
    "#6b8e23",
    "#FF8042",
    "#FFBB28",
    "#dc143c",
    "#008b8b",
    "#b8860b",
    "#bdb76b",
    "#a9a9a9",
    "#8b0000",
    "#e9967a",
    "#0088FE",
    "#00ced1",
    "#6b8e23",
    "#FF8042",
    "#FFBB28",
    "#dc143c",
    "#008b8b",
    "#b8860b",
    "#bdb76b",
    "#a9a9a9",
    "#8b0000",
    "#e9967a",
    "#0088FE",
    "#00ced1",
    "#6b8e23",
    "#FF8042",
    "#FFBB28",
    "#dc143c",
    "#008b8b",
    "#b8860b",
    "#bdb76b",
    "#a9a9a9",
    "#8b0000",
    "#e9967a",
    "#0088FE",
    "#00ced1",
    "#46F3EA",
    "#FF8042",
    "#FFBB28",
    "#dc143c",
    "#008b8b",
    "#b8860b",
    "#bdb76b",
    "#a9a9a9",
    "#8b0000",
    "#e9967a",
    "#0088FE",
    "#00ced1",
    "#6b8e23",
    "#FF8042",
    "#FFBB28",
    "#dc143c",
    "#008b8b",
    "#b8860b",
    "#bdb76b",
    "#a9a9a9",
    "#8b0000",
    "#e9967a",
    "#0088FE",
    "#00ced1",
    "#6b8e23",
    "#FF8042",
    "#FFBB28",
    "#dc143c",
    "#008b8b",
    "#b8860b",
    "#bdb76b",
    "#a9a9a9",
    "#8b0000",
    "#e9967a",
    "#0088FE",
    "#00ced1",
    "#6b8e23",
    "#FF8042",
    "#FFBB28",
    "#dc143c",
  ];

  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
    index,
  }) => {
    const RADIAN = Math.PI / 180;
    const radius = 25 + innerRadius + (outerRadius - innerRadius);
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    const textAnchor = x > cx ? "start" : "end";

    return (
      <g>
        <text
          x={x}
          y={y}
          fill="black"
          textAnchor={textAnchor}
          dominantBaseline="central"
          style={{ fontSize: "13px" }} // Adjust font size here
        >
          {`${(percent * 100).toFixed(0)}%`}
        </text>
        <line
          x1={cx + (outerRadius + 10) * Math.cos(-midAngle * RADIAN)}
          y1={cy + (outerRadius + 10) * Math.sin(-midAngle * RADIAN)}
          x2={x}
          y2={y}
          stroke="black"
          strokeWidth="1"
        />
      </g>
    );
  };

  // Function to convert amount to lakhs
  const formatToLakhs = (amount) => {
    if (amount >= 100000 || amount >= 0) {
      return (amount / 100000).toFixed(2);
    }
    return amount.toFixed(2);
  };

  // Validate "To" date when it changes
  const validateToDate = (newToDate) => {
    if (fromDate) {
      const from = new Date(fromDate);
      const maxToDate = new Date(from.setDate(from.getDate() + 366))
        .toISOString()
        .split("T")[0];

      if (newToDate > maxToDate) {
        toast.error(
          'The "To" date must be within 366 days after the "From" date.'
        );
        setToDate(maxToDate); // Reset to maximum allowed date
      } else {
        setToDate(newToDate);
      }
    }
  };

  //for consider max value in graph
  const maxValue = Math.max(...revenuedata.map((data) => data.total_amount));
  console.log(customerWiseRevenuedata);
  const basicSales = customerWiseRevenuedata.reduce(
    (total, data) => total + Number(data.item_amount),
    0
  );
  const totalSales = customerWiseRevenuedata.reduce(
    (total, data) => total + Number(data.total_amount),
    0
  );
  const totalCustomers = customerWiseRevenuedata.length || 0; // Ensure it's at least 0
  const topCustomer = customerWiseRevenuedata.reduce(
    (max, data) =>
      Number(data.item_amount) > Number(max.item_amount) ? data : max,
    { customername: "", item_amount: 0 }
  );

  const topCustomerName = topCustomer.suppliername;

  const columnDefs = useMemo(
    () => [
      {
        headerName: "Supplier",
        field: "suppliername",
        flex: 2,
        tooltipField: "suppliername",
        cellClass: "truncate text-gray-800 font-semibold",
      },
      {
        headerName: "Basic Sale (Lakhs)",
        field: "item_amount",
        flex: 1,
        // type: "rightAligned",
        valueFormatter: (params) => formatToLakhs(Number(params.value)),
        cellClass: "text-gray-800 font-semibold",
      },
      {
        headerName: "Total Sale (Lakhs)",
        field: "total_amount",
        flex: 1,
        // type: "rightAligned",
        valueFormatter: (params) => formatToLakhs(Number(params.value)),
        cellClass: "text-gray-800 font-semibold",
      },
    ],
    []
  );
  const pinnedRow = [
    {
      suppliername: "Total Sale (Lakhs)",
      item_amount: basicSales,
      total_amount: totalSales,
    },
  ];

  return (
    <>
      <ToastContainer />
      <div className="w-full flex flex-col">
        <div className="flex justify-between items-start my-1 gap-1">
          {!hiddenSection && (
            <>
              <div className="flex flex-row items-center w-full">
                <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
                  From
                </Text>
                <input
                  name="from_date"
                  type="date"
                  value={fromDate}
                  // onChange={(e) => setFromDate(e.target.value)}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                    validateToDate(toDate); // Validate "To" date whenever "From" date changes
                  }}
                  className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
                />
                <Text className="text-sm md:text-[22px] text-gray-600 sm:text-xl pt-2 mr-2 ml-2 mb-2">
                  To
                </Text>
                <input
                  name="to_date"
                  type="date"
                  value={toDate}
                  // onChange={(e) => setToDate(e.target.value)}
                  onChange={(e) => validateToDate(e.target.value)}
                  className="bg-white-A700 border border-gray-400_02 border-solid h-9 rounded-[5px] text-sm"
                />
                <CustomSelect
                  options={[
                    { label: "All Supplier", value: "" },
                    ...supplierList.map((customer) => ({
                      label: customer.name,
                      value: customer.id,
                    })),
                  ]}
                  className="bg-white-A700 border border-gray-200_02 border-solid h-9 ml-2 rounded-md w-[20%] text-sm "
                  onChange={(selectedOption) => {
                    setSupplierId(selectedOption.value);
                    setShowChart(true);
                    setFlag(true);
                  }}
                  placeholder="All Supplier"
                  key={resetkey}
                />
              </div>

              <div className="flex items-center">
                <div
                  className="flex flex-col relative z-20 "
                  onMouseEnter={() => setDownload(true)}
                  onMouseLeave={() => setDownload(false)}
                >
                  <button
                    id="dropdownDefaultButton"
                    data-dropdown-toggle="dropdown"
                    className="text-white-A700 bg-blue-700 hover:bg-blue-800 font-medium rounded-lg text-sm px-3 py-1.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 w-28 mr-4 "
                    type="button"
                  >
                    {"Download"} &nbsp;
                    <svg
                      className="w-2.5 h-2.5 ms-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 10 6"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 4 4 4-4"
                      />
                    </svg>
                  </button>
                  <div
                    className={`${
                      download ? "absolute top-[32px]" : "hidden"
                    } z-20 bg-white divide-y divide-gray-100 rounded-lg shadow w-[110px] bg-white-A700  dark:bg-gray-700`}
                  >
                    <ul
                      className="py-0 text-sm text-gray-700 dark:text-gray-200"
                      aria-labelledby="dropdownDefaultButton"
                    >
                      <li>
                        <span
                          className="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                          onClick={() => DownloadExcel()}
                        >
                          Excel
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="grid grid-cols-4 sm:grid-cols-2 md:grid-cols-3 px-2 gap-3">
          <div className=" shadow-md border border-gray-300 rounded-xl p-4 flex flex-col items-start hover:shadow-lg hover:shadow-blue-300 transition-shadow duration-300">
            <div className="flex items-center gap-2 w-full">
              <span className="text-sm text-gray-700 font-semibold">
                Basic Purchase
              </span>
              <FaChartLine className="text-blue-500 ml-auto" size={16} />
            </div>
            <span className="text-sm font-semibold text-blue-500 ">
              {formatRupee(basicSales)}
            </span>
          </div>
          <div className=" shadow-md border border-gray-300 rounded-xl p-4 flex flex-col items-start hover:shadow-lg hover:shadow-blue-300 transition-shadow duration-300">
            <div className="flex items-center gap-2 w-full">
              <span className="text-sm  text-gray-700 font-semibold">
                {" "}
                Total Purchase
              </span>
              <FaMoneyBillWave className="text-blue-500 ml-auto" size={16} />
            </div>
            <span className="text-sm font-semibold text-blue-500">
              {formatRupee(totalSales)}
            </span>
          </div>

          <div className=" shadow-md border border-gray-300 rounded-xl p-4 flex flex-col items-start hover:shadow-lg hover:shadow-blue-300 transition-shadow duration-300">
            <div className="flex items-center gap-2 w-full">
              <span className="text-sm  text-gray-700 font-semibold">
                Top Supplier
              </span>
              <FaUserTie className="text-blue-500 ml-auto" size={16} />
            </div>
            <span
              className="text-sm font-semibold text-blue-500 truncate max-w-full  "
              title={topCustomerName}
            >
              {topCustomerName || "N/A"}
            </span>
          </div>
          <div className=" shadow-md border border-gray-300 rounded-xl p-4 flex flex-col items-start hover:shadow-lg hover:shadow-blue-300 transition-shadow duration-300">
            <div className="flex items-center gap-2 w-full">
              <span className="text-sm  text-gray-700 font-semibold">
                Total Suppliers
              </span>
              <FaUsers className="text-blue-500 ml-auto" size={16} />
            </div>
            <span className="text-sm font-semibold text-blue-500">
              {totalCustomers}
            </span>
          </div>
        </div>
        <div className="flex flex-wrap gap-3 p-2 ">
          {/* Pie Chart Card */}
          <div className="flex-1 min-w-[300px] max-w-[400px] border border-gray-300 shadow-lg rounded-lg bg-white-A700 hover:shadow-xl hover:shadow-blue-300 transition-shadow duration-300">
            <ResponsiveContainer width="100%" height={300}>
              {pieChartDate.length ? (
                <PieChart>
                  <Pie
                    data={pieChartDate}
                    cx="50%"
                    cy="40%"
                    labelLine={false}
                    label={renderCustomizedLabel}
                    outerRadius={90}
                    fill="#8884d8"
                    dataKey="total_amount"
                  >
                    {pieChartDate.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip content={<CustomTooltipforPie />} />
                </PieChart>
              ) : (
                <div className="flex justify-center items-center h-full w-full text-gray-500">
                  No report available
                </div>
              )}
            </ResponsiveContainer>
          </div>

          {/* Bar Chart Card */}
          <div className="flex-1 min-w-[300px] border border-gray-300 shadow-lg rounded-lg bg-white-A700 hover:shadow-xl hover:shadow-blue-300 transition-shadow duration-300">
            <ResponsiveContainer width="100%" height={300}>
              {revenuedata.length ? (
                <BarChart
                  layout="vertical"
                  data={revenuedata}
                  margin={{ top: 20, right: 50, bottom: 5, left: 20 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <Legend
                    verticalAlign="bottom"
                    wrapperStyle={{ fontSize: "12px" }}
                  />
                  <ReferenceLine x={0} stroke="#000" />
                  <XAxis
                    type="number"
                    domain={[0, maxValue * 1.1]}
                    tickFormatter={(value) =>
                      value >= 1000000
                        ? `${(value / 1000000).toFixed(1)}M`
                        : value >= 100000
                        ? `${(value / 100000).toFixed(1)}L`
                        : value >= 1000
                        ? `${(value / 1000).toFixed(1)}K`
                        : value.toFixed(0)
                    }
                    tick={{ fontSize: 12, fill: "#4B5563" }} // subtle dark gray text
                  />
                  <YAxis
                    type="category"
                    dataKey="month_name"
                    tickFormatter={(month) => month.slice(0, 3)}
                    tick={{ fontSize: 12, fill: "#4B5563" }} // subtle dark gray text
                  />
                  <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{ fontSize: "12px" }}
                  />
                  <Bar
                    dataKey="total_amount"
                    name="Amount"
                    fill="#2196F3"
                    barSize={32}
                    radius={[4, 4, 4, 4]} // subtle rounding// top-left, top-right, bottom-right, bottom-left
                  >
                    <LabelList
                      dataKey="total_amount"
                      position="right"
                      formatter={(value) => formatRupee(value)}
                      style={{ fontSize: "12px", fill: "#333" }} // dark label color for clarity
                    />
                  </Bar>
                </BarChart>
              ) : (
                <div className="flex justify-center items-center h-full w-full text-gray-500">
                  No report available
                </div>
              )}
            </ResponsiveContainer>
          </div>
        </div>
        {/* ===== Data Table ===== */}
        <div
          className="ag-theme-quartz rounded-xl shadow-md overflow-hidden border border-gray-200  mx-2 mb-2 hover:shadow-blue-300 hover:shadow-xl "
          style={{ height: 300 }}
        >
          <AgGridReact
            rowData={customerWiseRevenuedata}
            columnDefs={columnDefs}
            defaultColDef={{
              sortable: true,
              filter: true,
              resizable: true,
            }}
            getRowClass={(params) => {
              if (params.node.rowPinned === "bottom") {
                return "bg-green-300 font-bold text-sm border-gray-400 text-gray-900";
              }
              return "";
            }}
            rowHeight={40}
            headerHeight={36}
            pinnedBottomRowData={pinnedRow}
          />
        </div>
      </div>
    </>
  );
});

export default SupplierSalesReport;
